<template>
  <div class="moving-select-goods">
    <a-affix class="top-affix" :offset-top="0" :target="backTopTarget">
      <TopTabs :activeKey="activeKey" :activekeyList="activekeyList" :routeKey="routeKey" @changeActiveKey="changeActiveKey" />
    </a-affix>
    <div class="box">
      <a-space class="item">
        <a-affix class="top-affix" :offset-top="33" :target="backTopTarget">
          <component :is="currentItem.component" :params="currentItem" @searchGoods="searchGoods" />
        </a-affix>
        <!-- 全选区域 -->
        <a-space style="flex-wrap: wrap;">
          <BatchOperateButton text="铺货预览" ref="batchOperateButton"
            :canCommitRepeat="this.$refs.createGoodsTemplateModal?.currentGoodsTemplate?.is_repeat"
            :list="getGoodsList" :selectedRows="getSelectedRows"
            @click-batch="batchAddPreview" @change-check-all="changeCheckAll" />
          <CreateGoodsTemplateModal ref="createGoodsTemplateModal" :hideOpenDouyinButton="true" />
        </a-space>
      </a-space>
      <template v-if="currentItem.tipMessage">
        <a-tag color="red" class="pallet-tip">{{ currentItem.tipMessage }}</a-tag>
        <br />
      </template>
      <a-spin style="min-height: 120px" :spinning="loading" tip="正在加载数据中，请耐心等待" size="large">
        <GoodsList 
          :list="getGoodsList" 
          :description="currentItem.description"
          :canCommitRepeat="this.$refs.createGoodsTemplateModal?.currentGoodsTemplate?.is_repeat" 
          :isTaoteKeyword="currentItem.value === 'taoteKeyword'" 
          :isTaoteKeyword2="currentItem.value === 'taoteKeyword2' || currentItem.value === 'taoteKeyword3'" 
          :isAliKeyword="currentItem.type === 'ali'"
          @add-preview="singleAddPreview"
          @click-item="clickItem"
        />
      </a-spin>
      <div v-if="currentItem.list?.length > 8" class="bottom-box">
        <BatchOperateButton 
          :canCommitRepeat="this.$refs.createGoodsTemplateModal?.currentGoodsTemplate?.is_repeat" 
          text="铺货预览" 
          :list="getGoodsList"
          :selectedRows="getSelectedRows"
          @click-batch="batchAddPreview"
          @change-check-all="changeCheckAll" 
        />
        <a-pagination
          v-show="!currentItem.hidePage"
          v-model:current="currentItem.params.page"
          v-model:pageSize="currentItem.params.size"
          showSizeChanger
          :showTotal="total => `共 ${total} 个商品`"
          :total="currentItem.params.total"
          :pageSizeOptions="currentItem.value === 'aliKeyword' ? ['20', '30'] : (currentItem.pageSizeOptions || ['20', '50', '100'])"
          @change="changePage"
          @showSizeChange="changePage"
        />
        <div v-show="currentItem.hidePage" style="margin-right: 3em">共 {{ currentItem.list.length}} 个商品</div>
      </div>
    </div>
    <AuthTaoteModal ref="authTaoteModal" @success="initData" />
    <a-tooltip placement="top">
      <template #title>
        <span>点我返回顶部</span>
      </template>
      <a-back-top class="backtop" :target="backTopTarget" />
    </a-tooltip>
  </div>
</template>
<script>
import AuthTaoteModal from "@/views/moving_function/components/auth_taote_modal"
import handler from "./handler"
import GoodsList from "./components/goods_list"
import CreateGoodsTemplateModal from '@/views/moving_function/components/create_goods_template_modal'
import { SearchOutlined } from "@ant-design/icons-vue"
import TopTabs from './components/top_tabs'
import BatchOperateButton from './components/batch_operate_button'
import options from './options'
const routeArr = ['flpPallet', 'taote_movingFunction', 'ali_movingFunction']
export default {
  components: {
    AuthTaoteModal,
    GoodsList,
    SearchOutlined,
    CreateGoodsTemplateModal,
    TopTabs,
    BatchOperateButton
  },
  data() {
    return {
      activekeyList: options.activekeyList,
      activeKey: "",
      loading: false,
      routeKey: "",
      selectClueList: [],
      categoryList: [],
    }
  },
  computed: {
    currentItem() {
      return this.activekeyList.find(item => item.value === this.activeKey) || this.activekeyList[0]
    },
    getSelectedRows() {
      return this.currentItem.selectedList || []
    },
    getGoodsList() {
      if (this.getSelectedRows?.length) {
        this.currentItem.list.map(item => {
          item.selected = this.getSelectedRows.find(i => i.id === item.id)?.selected
        })
      }
      return this.currentItem.list || []
    }
  },
  methods: {  
    // 初始化
    async initData() {
      handler.InitData(this)
    },
    // 切换分页 / 改变每页条数时
    async changePage(page, size) {
      this.currentItem.params.page = page
      this.currentItem.params.size = size
      handler.GetData(this)
    },
    // 点击搜索按钮
    searchGoods() {
      this.currentItem.params.page = 1
      this.clearSelectedGoods()
      handler.GetData(this)
    },
    // 单个商品铺货预览
    singleAddPreview(item) {
      handler.SingleAddPreview(this, item)
    },
    // 批量商品铺货预览
    batchAddPreview() {
      handler.BatchAddPreview(this)
    },
    // 切换Tab
    changeActiveKey(val) {
      this.activeKey = val
      const { value, api, list } = this.currentItem
      if (!list?.length && api) {
        this.currentItem.isGeted = true
        handler.GetData(this, value)
      }
    },
    // 打开新页面
    openPage(url) {
      window.open(url)
    },
    // 清空已选择的商品
    clearSelectedGoods() {
      handler.ClearSelectedGoods(this.currentItem)
    },
    // 点击商品时触发
    clickItem(item) {
      handler.ClickItem(this.currentItem.selectedList, item)
    },
    // 点击全选时触发
    changeCheckAll(bool) {
      handler.ChangeCheckAll(bool, this.currentItem, this.$refs.createGoodsTemplateModal)
    },
    // 返回顶部
    backTopTarget() {
      return document.querySelector('.moving-select-goods')
    },
    setActiveKey() {
      this.$emit('changeTab', 'selectGoods')
      this.activeKey = this.activekeyList.find(item => item.routeKey === this.routeKey)?.value || this.activekeyList[0]?.value
      this.initData()
    }
  },
  watch: {
    $route: {
      handler(params) {
        if (routeArr.includes(params.name)) {
          this.routeKey = params.name
          this.activekeyList = options.activekeyList
          this.setActiveKey()
        }
      },
      immediate: true
    }
  }
}
</script>
<style lang="less" scoped>
  @import './index';
</style>
<style lang='less'>
  @import './index2';
</style>